import { DeleteList } from '@/components/Contacts/CommonActions/Delete';
import { useSelectedEntity } from '@/components/Contacts/Group/hooks';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ListDeleteStart } from '@/store/lists/actions';
import { SegmentDeleteStart } from '@/store/segments/actions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const useDelateSelectedEntity = () => {
    const { t } = useTranslation();
    const { isSelectedEntityAList, selectedEntity } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);
    const dispatch = useDispatch();

    const params: ShowDialogParams = {
        title: isList ? t('deletelist') : t('deletesegment'),
        destructiveLabel: t('delete'),
        onClickDestructive: (): void => {
            !isList
                ? dispatch(SegmentDeleteStart(selectedEntity.Name))
                : dispatch(ListDeleteStart(selectedEntity.ListName));
        },
        cancelLabel: t('cancel'),
        body: <DeleteList isList={isList} />,
    };

    const deleteSelectedEntity = () => {
        dispatch(ShowDialog(params));
    };

    return { deleteSelectedEntity };
};
